export const CURRENCIES = [
  {
    code: 'EUR',
    symbol: '€',
    label: 'Euros',
  },
  {
    code: 'GBP',
    symbol: '£',
    label: 'Pounds Sterling',
  },
  {
    code: 'USD',
    symbol: '$',
    label: 'Dollars',
  },
  {
    code: 'AUD',
    symbol: '$',
    label: 'Australian Dollars',
  },
];

export const ERROR_CONSTANTS = {
  SEATS_UNAVAILABLE: 'SEATS_UNAVAILABLE'
};

export const MODES = {
  FIXED_PACKAGE: 'FIXED_PACKAGE',
  FIXED_PACKAGE_PERFORMANCE: 'FIXED_PACKAGE_PERFORMANCE',
  FLEX_PACKAGE_PERFORMANCE: 'FLEX_PACKAGE_PERFORMANCE',
  PERFORMANCE: 'PERFORMANCE'
};

/**
 * Using constants allows us to throw an
 * error if an unavailable action is used.
 *
 * The number of actions should be kept to
 * a minimum, instead prefer passing
 * state down through React components.
 *
 * The actions are here primarily so allow
 * communication accross the app between
 * non-React components (e.g. the seat-map DOM)
 * and React components.
 */
export const ACTION_CONSTANTS = {
  SEAT_SELECTED: 'SEAT_SELECTED',
  SEAT_ADDED: 'SEAT_ADDED',
  SEAT_DESELECTED: 'SEAT_DESELECTED',
  SEAT_TOGGLE_SELECTED: 'SEAT_TOGGLE_SELECTED',

  LEVEL_SELECTED: 'LEVEL_SELECTED',
  LEVEL_PRESELECTED: 'LEVEL_PRESELECTED',
  SCREEN_FILTER_SELECTED: 'SCREEN_FILTER_SELECTED',
  PRICE_FILTER_SELECTED: 'PRICE_FILTER_SELECTED',

  UPDATE_CART_DETAILS: 'UPDATE_CART_DETAILS',
};



// WEBPACK FOOTER //
// ./src/javascripts/constants.js